import { enrollAutomaticPaymentData } from "constants-lib/seo/enrollAutomaticPaymentData"
import { addJSONLDToHead, removeElement } from "./jsonLD.js"

export const getEnrollAutomaticPaymentData = (schemaData) => {
  const data = schemaData.map((item) => ({
    "@type": `Question`,
    name: item.Question,
    acceptedAnswer: {
      "@type": `Answer`,
      text: item.Answer,
    },
  }))
  return data
}

/* Add Enroll Automatic Payment JSON LD if needed, otherwise make sure it does not exist in Head. */
export const addEnrollAutomaticPaymentData = () => {
  if (
    window.location.href.includes(
      `/us/en/support/faqs/video-can-you-show-me-how-to-enroll-in-automatic-payments-autopay`,
    ) &&
    document.getElementById(`enrollAutomaticPayment`) === null
  ) {
    const script = enrollAutomaticPaymentJSONLD()
    addJSONLDToHead(script, `enrollAutomaticPayment`)
  } else {
    removeElement(`enrollAutomaticPayment`)
  }
}

// JSON LD template for Enroll Automatic Payment
const enrollAutomaticPaymentJSONLD = () => {
  const enrollAutomaticTemplate = {
    "@context": `http://schema.org`,
    "@type": `FAQPage`,
    mainEntity: getEnrollAutomaticPaymentData(enrollAutomaticPaymentData),
  }
  return enrollAutomaticTemplate
}
